import { DocumentNode, gql } from "@apollo/client";

class DrawRequestService {
  public static createDrawRequest = (): DocumentNode => gql`
    mutation CreateDrawRequest(
      $orderUidPublic: String!
      $testUid: String!
      $requestData: DrawRequestCreateInputDTO!
      $token: String
      $isPublicRequest: Boolean
    ) {
      createDrawRequest(
        orderUidPublic: $orderUidPublic
        testUid: $testUid
        requestData: $requestData
        token: $token
        isPublicRequest: $isPublicRequest
      ) {
        success
        reqId
      }
    }
  `;

  public static updateDrawRequest = (): DocumentNode => gql`
    mutation UpdateDrawRequest(
      $testUid: String!
      $requestData: DrawRequestUpdateInputDTO!
      $token: String
    ) {
      updateDrawRequest(
        testUid: $testUid
        requestData: $requestData
        token: $token
      ) {
        success
        reqId
      }
    }
  `;

  public static getDrawRequestDetails = (): DocumentNode => gql`
    query GetDrawRequestDetails(
      $orderUidPublic: String!
      $testUid: String!
      $token: String
    ) {
      getDrawRequestDetails(
        orderUidPublic: $orderUidPublic
        testUid: $testUid
        token: $token
      ) {
        clinic {
          limsId
          name
        }
        drawRequest {
          uid
          shippingAddress {
            city
            street
            state
            zipCode
          }
          jobTimezone
          jobStatus
          start1
          start2
          start3
          end1
          end2
          end3
          note
          jobStart
          jobEnd
        }
      }
    }
  `;

  public static cancelDrawRequest = (): DocumentNode => gql`
    mutation CancelDrawRequest(
      $orderUidPublic: String!
      $testUid: String!
      $requestUid: String!
    ) {
      cancelDrawRequest(
        orderUidPublic: $orderUidPublic
        testUid: $testUid
        requestUid: $requestUid
      ) {
        success
      }
    }
  `;

  public static checkPhoneIsRequired = (): DocumentNode => gql`
    query CheckPhoneIsRequired($token: String!) {
      checkPhoneIsRequired(token: $token) {
        isRequired
      }
    }
  `;

  public static checkSampleDrawRequestPossibility = (): DocumentNode => gql`
    query CheckSampleDrawRequestPossibility(
      $testData: DrawRequestCheckDTO!
      $token: String
    ) {
      checkSampleDrawRequestPossibility(testData: $testData, token: $token) {
        isValid
        needsKitShippingStep
        skipLabStep
      }
    }
  `;

  public static verifySampleDrawRequestPossibilityNonAuth =
    (): DocumentNode => gql`
      query verifySampleDrawRequestPossibilityNonAuth(
        $token: String!
        $dateOfBirth: String!
        $phone: String
        $flow: String
      ) {
        verifySampleDrawRequestPossibilityNonAuth(
          token: $token
          dateOfBirth: $dateOfBirth
          phone: $phone
          flow: $flow
        ) {
          profileInfo {
            isValid
            profile {
              uid
              firstName
              middleName
              lastName
              dateOfBirth
              addresses {
                uid
                countryCode
                city
                state
                street1
                street2
                zipCode
              }
            }
          }
          businessUnit
          sampleInfo {
            isDrawRequested
            sample {
              orderUidPublic
              testUid
              testType
              testTypes
              creationDate
              testCardStatus
              isOncologyOrder
              lims_clinic_id
              testName
              sampleCollectionDate
              organType
              resultExpectedByDate
              concatenatedTestNames
              physician
            }
          }
          intentToken
        }
      }
    `;

  public static matchPatientNonAuth = (): DocumentNode => gql`
    query matchPatientNonAuth(
      $patientNonAuthInfoData: PatientNonAuthInfoData!
      $recaptchaToken: String
      $recaptchaV2Token: String
    ) {
      matchPatientNonAuth(
        patientNonAuthInfoData: $patientNonAuthInfoData
        recaptchaToken: $recaptchaToken
        recaptchaV2Token: $recaptchaV2Token
      ) {
        token
        skipCommunicationPreferencesStep
        code
      }
    }
  `;

  public static sendDrawAtLabChoiceActivity = (): DocumentNode => gql`
    mutation SendDrawAtLabChoiceActivity(
      $orderUidPublic: String!
      $token: String
    ) {
      sendDrawAtLabChoiceActivity(
        orderUidPublic: $orderUidPublic
        token: $token
      ) {
        success
      }
    }
  `;
}

export default DrawRequestService;
